import type { ReactNode } from 'react';
import { Skeleton } from '@mui/material';
import { useScrollToTop } from '@/services/useScrollToTop';
import { FormLayout } from './FormLayout';
import type { FormLayoutProps } from './FormLayout';

type FormLayoutSkeletonProps = {
    children: ReactNode;
    fullHeight?: boolean;
    // A work in progress message, or just boolean true. We can use this during dev when adding new features
    wip?: ReactNode | boolean;
    mode?: FormLayoutProps['mode'];
};

export function FormLayoutSkeleton(props: FormLayoutSkeletonProps) {
    useScrollToTop();

    const { children, ...formLayoutProps } = props;
    return (
        <FormLayout
            title={<Skeleton width="50%" height={32} sx={{ minWidth: 300 }} />}
            subTitle={
                <Skeleton width="75%" height={24} sx={{ minWidth: 300 }} />
            }
            isBusy={false}
            isValid={false}
            continueButtonProps={{
                children: <Skeleton width="100%" />,
                onClick: () => null,
            }}
            {...formLayoutProps}
        >
            {children}
        </FormLayout>
    );
}
